import React, { useState } from "react";
import { useSelector } from "react-redux";
import Fliter from "../../common/filter/Fliter";
import {
  fetchAllCarsAsync,
  getCarsList,
  getfilter,
  getLoading,
} from "../../../features/bookings/carrentSlice";
import CarsList from "./CarsList";
import MainModal from "../../modals/MainModal";
import Loader from "../../../helpers/Loader";
import { scrollFunc } from "../../../helpers/helper";
import RentalFilter from "../../common/filter/RentalFilter";
import { useEffect } from "react";
import { useRef } from "react";
import {
  useSearchParams,
  createSearchParams,
  useNavigate,
  Link,
} from "react-router-dom";
import { useDispatch } from "react-redux";
import { getLogin } from "../../../features/userSlice";

const Carrent = () => {
  const scrollSection = useRef(null);
  const carsListting = useSelector(getCarsList);
  const [show, setShow] = useState(false);
  const [modal, setModal] = useState("login");
  const [carsList, setCarList] = useState([]);
  const [carListbackUp, setCarListbackUp] = useState([]);
  const [minPrice, setMinPirce] = useState(0);
  const [maxPrice, setMaxPrice] = useState(0);
  const [minKm, setMinKm] = useState(0);
  const [maxKm, setMaxKm] = useState(0);
  const [searchParams] = useSearchParams();
  const [respFilter, setRespFilter] = useState(false);
  const [loader, setLoader] = useState(true);
  const [queryData, setQueryData] = useState(
    Object.fromEntries([...searchParams])
  );
  const userDatas = useSelector(getLogin);
  const userData = JSON.parse(sessionStorage.getItem("userData")) || {};
  const { Authorization } =
    JSON.parse(sessionStorage.getItem("userData")) || {};
  const [previousLogin, setPreviousLogin] = useState(
    Object.keys(userData).length
  );

  const loading = useSelector(getLoading);
  const dispatch = useDispatch();

  useEffect(() => {
    if (loading === false) {
      setTimeout(() => {
        setLoader(false);
      }, 800);
    }
  }, [loading]);
  var MinPrices;
  var MaxPrices;
  var MinKiloMetres;
  var MaxKiloMetres;
  useEffect(() => {
    setCarList(carsListting);
    setCarListbackUp(carsListting);

    MinPrices = Math.min(...carsListting.map((price) => price.hourly_rate));
    MaxPrices = Math.max(...carsListting.map((price) => price.hourly_rate));

    MinKiloMetres = Math.min(...carsListting.map((km) => km.km_driven));
    MaxKiloMetres = Math.max(...carsListting.map((km) => km.km_driven));

    if (MaxPrices > 0) {
      setMinPirce(MinPrices);
      setMaxPrice(MaxPrices);
      setMinKm(MinKiloMetres);
      setMaxKm(MaxKiloMetres);
    }

    scrollSection.current?.scrollIntoView({ behavior: "smooth" });
  }, [carsListting]);

  const ListingHandler = (country) => {
    dispatch(fetchAllCarsAsync({ Authorization, country: country }));
  };

  useEffect(() => {
    if (Object.keys(userData).length > 0) {
      if (previousLogin === 0 && userData?.role === "Agent") {
        setPreviousLogin(1);
      }
    }
  }, [userDatas]);

  useEffect(() => {
    var start = Object.fromEntries([...searchParams]);
    let timings = JSON.parse(start.timings).country;
    if (Object.keys(queryData).length > 0) {
      ListingHandler(timings);
    }
  }, [searchParams, previousLogin]);

  const filter = (data) => {
    const FuelType = data["FuelType"];
    const CarType = data["CarType"];
    const GearType = data["GearType"];
    const Seats = data["Seats"];
    const Brand = data["Brand"];
    const PriceSort = data["PriceSort"];
    const PriceRange = data["PriceRange"];
    const KmDriven = data["KmDriven"];
    const Reset = data["Reset"];
    // FuelType.find((ty) => ty === t.fual_type) !== undefined

    var tempcarlist = carListbackUp;

    // FUEL TYPE
    tempcarlist = tempcarlist.filter((t) =>
      FuelType.length > 0 ? FuelType.includes(t.fual_type) : true
    );

    // GEAR TYPE
    if (GearType.length > 0) {
      tempcarlist = tempcarlist.filter((t) =>
        GearType.length > 0 ? GearType.includes(t.gear_type) : true
      );
    }

    // CAR TYPE
    if (CarType.length > 0) {
      tempcarlist = tempcarlist.filter((t) =>
        CarType.length > 0 ? CarType.includes(t.cars_type.name) : true
      );
    }

    // SEATS
    if (Seats.length > 0) {
      tempcarlist = tempcarlist.filter((t) =>
        Seats.length > 0 ? Seats.includes(t.seat_capacity) : true
      );
    }

    // BRANDS
    if (Brand.length > 0) {
      tempcarlist = tempcarlist.filter((t) =>
        Brand.length > 0 ? Brand.includes(t.cars_brand["name"]) : true
      );
    }

    //PRICE SORTING
    if (PriceSort.length > 0) {
      if (PriceSort[0] === "MinToMax") {
        tempcarlist = tempcarlist.sort(
          (a, b) => parseFloat(a.hourly_rate) - parseFloat(b.hourly_rate)
        );
      } else {
        tempcarlist = tempcarlist.sort(
          (a, b) => parseFloat(b.hourly_rate) - parseFloat(a.hourly_rate)
        );
      }
    }

    //PRICE RANGE
    if (PriceRange.length > 0) {
      tempcarlist = tempcarlist.filter(
        (p) => p.hourly_rate >= PriceRange[0] && p.hourly_rate <= PriceRange[1]
      );
    }

    //KM DRIVEN
    if (KmDriven.length > 0) {
      tempcarlist = tempcarlist.filter(
        (km) =>
          parseInt(km.km_driven) >= KmDriven[0] &&
          parseInt(km.km_driven) <= KmDriven[1]
      );
    }

    //RESET
    if (Reset) {
      tempcarlist = carListbackUp;

      setMaxPrice("");
      setMinPirce("");
      setMaxKm("");
      setMinKm("");
      var MinPrices2 = Math.min(
        ...carsListting.map((price) => price.hourly_rate)
      );
      var MaxPrices2 = Math.max(
        ...carsListting.map((price) => price.hourly_rate)
      );

      var MinKiloMetres2 = Math.min(...carsListting.map((km) => km.km_driven));
      var MaxKiloMetres2 = Math.max(...carsListting.map((km) => km.km_driven));

      setTimeout(() => {
        setMaxPrice(MaxPrices2);
        setMinPirce(MinPrices2);
        setMinKm(MinKiloMetres2);
        setMaxKm(MaxKiloMetres2);
      }, 700);
      // ResetHandler
      // ListingHandler();
    }

    setCarList(tempcarlist);
  };

  const resFilterNavigation = (type) => {
    if (type === "open") {
      setRespFilter(true);
    } else {
      setRespFilter(false);
    }
  };

  // if (loading) {
  //   return <Loader />;
  // }

  return (
    <>
      <section className="transfer" ref={scrollSection}>
        <div
          className={respFilter ? "filter-backdrop active" : "filter-backdrop"}
          onClick={() => resFilterNavigation("close")}
        ></div>
        <div
          className={respFilter ? "navigation navigation-active" : "navigation"}
        >
          <RentalFilter
            filterData={(data) => {
              filter(data);
            }}
            maxp={maxPrice}
            minp={minPrice}
            minKms={minKm}
            maxKms={maxKm}
          />
        </div>
        <div className="container position-relative">
          <div className="row">
            <div className="col-xl-3 for-desktop-screen">
              <RentalFilter
                filterData={(data) => {
                  filter(data);
                }}
                maxp={maxPrice}
                minp={minPrice}
                minKms={minKm}
                maxKms={maxKm}
              />
            </div>

            <div className="col-xl-9">
              <div className="responsive-sidebar">
                <div>
                  <div
                    className="nav-btn"
                    onClick={() => resFilterNavigation("open")}
                  >
                    <img
                      src="assets/images/filter-icon.svg"
                      className="filter-icon"
                      alt="filter-icon"
                    />
                  </div>
                </div>
                <div className="flight-breadcrumb">
                  <div aria-label="breadcrumb">
                    <ol className="breadcrumb m-0">
                      <li className="breadcrumb-item">
                        <Link to={"/"}>Home</Link>
                      </li>
                      <li
                        className="breadcrumb-item active"
                        aria-current="page"
                      >
                        Flight Listing
                      </li>
                    </ol>
                  </div>
                </div>
              </div>

              {loader ? (
                <div className="hotel-listing-wrap gray-border">
                  <div className="row justify-content-between align-items-center w-100">
                    <div className="col-lg-3">
                      <div className="loader-bg structure-box2"></div>
                    </div>
                    <div className="col-lg-6">
                      <span className="loader-bg p-3 mb-2 d-block w-25 rounded"></span>
                      <span className="loader-bg pt-4 mb-2 d-block w-50 me-2 rounded"></span>
                      <span className="loader-bg pt-4 mb-2 d-block w-25 me-2 rounded"></span>
                      <span className="loader-bg pt-4 mb-2 d-block w-50 me-2 rounded"></span>
                      <span className="loader-bg pt-4 mb-2 d-block w-50 me-2 rounded"></span>
                    </div>
                    <div className="col-lg-3">
                      <span className="loader-bg p-3 mb-2 d-block w-25 rounded"></span>
                      <span className="loader-bg p-3 mb-2 d-block w-50 rounded"></span>
                      <span className="loader-bg pt-4 mb-2 d-block w-75 me-2 rounded"></span>
                      <span className="loader-bg pt-4 mb-2 d-block w-50 me-2 rounded"></span>
                    </div>
                  </div>
                </div>
              ) : carsList.length > 0 ? (
                carsList.map((ele, i) => {
                  return (
                    <CarsList
                      carDetail={ele}
                      show={show}
                      setShow={setShow}
                      setModal={setModal}
                      Book={true}
                      key={i}
                    />
                  );
                })
              ) : (
                <div className="transfer-wrap">
                  <div className="row align-items-center">
                    <div className="col-lg-3">
                      <div className="car-rental-image-wrap">
                        <img
                          src="/assets/images/car-rental/no-car.svg"
                          alt=""
                        />
                      </div>
                    </div>
                    <div className="col-lg-9">
                      <div className="transfer-inner no-cars-wrap">
                        <h4 className="bold20">
                          Looks empty, you've no Cars Available
                        </h4>
                        <p>Please modify your search for more cars</p>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        {show ? (
          <MainModal
            modal={modal}
            setShow={setShow}
            show={show}
            setModal={setModal}
            // extraData={val.DayRates[0]}
          />
        ) : null}
      </section>
    </>
  );
};

export default Carrent;
